import * as React from "react"

type ContainerProps = {
  children: React.ReactNode
}

export const Container = (props: ContainerProps) => {
  return <div className="max-w-7xl mx-auto px-4">{props.children}</div>
}
